import { render, staticRenderFns } from "./CarouselModal.vue?vue&type=template&id=7e0c78e4&"
import script from "./CarouselModal.vue?vue&type=script&lang=js&"
export * from "./CarouselModal.vue?vue&type=script&lang=js&"
import style0 from "./CarouselModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCarousel,VCarouselItem,VDialog,VIcon,VOverlay})
